import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { UserService } from 'src/app/shared/API-Service/services/user.service';
import { SectorService } from 'src/app/shared/API-Service/services/sector.service';
import { timestamp } from 'rxjs/operators';


@Component({
  selector: 'app-insert-user',
  templateUrl: './insert-user.component.html',
  styleUrls: ['./insert-user.component.css']
})
export class InsertUserComponent implements OnInit {
  recordtoupdate:any;
  userForm:FormGroup ;
  update:boolean = false;
  button:boolean = false;
  constructor(private _UserService:UserService,private _Router:Router,private _FormBuilder:FormBuilder) { }

  ngOnInit(): void {
    this.initiate();
    this.checkEdit();
  }

  initiate(){
    this.userForm = this._FormBuilder.group({
      name: ['', Validators.required],
      userName: ['', Validators.required],
      passwordHash: ['', Validators.required],
    });
  }
  get fc() {
    return this.userForm.controls;
  }
  checkEdit() {
    this._UserService.Data.subscribe((res) => {
      if (res != null) {
        this.userForm = this._FormBuilder.group({
          name: [res.name, Validators.required],
          userName: [res.userName, Validators.required],
          passwordHash: [res.passwordHash, Validators.required],
        });
        
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
     
    });
  }

  onSubmit(){
    this.button = true;
   if(this.update == false && this.userForm.status == "VALID"){
  
    this._UserService.CreateUser(this.userForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.userForm.reset();
      this._Router.navigate(['/content/admin/ViewUser']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"    
    }) 
    this.button = false ;
    this.userForm.markAllAsTouched();
   }
  }
  
  
  ngOnDestroy(){
    this._UserService.Data.next(null);
     }
  


}
